export default {
      id: "register-claim-usage",
      viewBox: "0 0 33 33",
      url: __webpack_public_path__ + "sprite.svg#register-claim",
      toString: function () {
        return this.url;
      }
    }